<router-outlet *ngIf="!loading"></router-outlet>

<div class="loading-spinner sm-bg-white" *ngIf="loading">
  <div class="cc-icon cc-icon-spinner-3x"></div>
</div>
